import { BookingQuestionUiContainer } from 'common/components/entities/Calendar/ui/booking-question/booking-question-container'
import { BookingQuestionLabel } from 'common/components/entities/Calendar/ui/booking-question/booking-question-label'
import CommonField from 'common/components/entities/Field/FieldUi'
import {
  BookingCalendarFieldProps,
  BookingFormQuestion,
} from 'common/types/entities/BookingCalendarInterface'
import { QuestionAnswer } from 'publisher/store/optIn/optInStateInterface'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export interface BookingCalendarQuestionProps
  extends BookingCalendarFieldProps {
  question: BookingFormQuestion
  customQuestions?: QuestionAnswer[]
  setCustomQuestions?: Dispatch<SetStateAction<QuestionAnswer[]>>
}

export const BookingCalendarQuestion = ({
  question,
  fieldFontSize,
  mobileFieldFontSize,
  fieldLineHeight,
  mobileFieldLineHeight,
  formFieldTextColor,
  mobileFormFieldTextColor,
  formFieldPlaceholderColor,
  mobileFormFieldPlaceholderColor,
  fieldBorder = {},
  mobileFieldBorder,
  fieldBoxShadow,
  mobileFieldBoxShadow,
  customQuestions,
  setCustomQuestions,
}: BookingCalendarQuestionProps) => {
  const { t } = useTranslation()
  const answerId = question.answers[0]?.id
  const value = customQuestions?.find(
    customQuestion => customQuestion.id === question.id,
  )?.answers[0].openAnswer

  const handleQuestionUpdate = (answerId: string, newValue: string) => {
    if (!setCustomQuestions) return
    const isExistingQuestion = customQuestions?.some(
      customQuestion => customQuestion.id === question.id,
    )

    if (isExistingQuestion) {
      setCustomQuestions(prevCustomQuestions =>
        prevCustomQuestions.map(customQuestion =>
          customQuestion.id === question.id
            ? {
                ...customQuestion,
                answers: [
                  {
                    id: answerId,
                    openAnswer: newValue,
                  },
                ],
              }
            : customQuestion,
        ),
      )
    } else {
      setCustomQuestions(prevCustomQuestions =>
        prevCustomQuestions.concat([
          {
            id: question.id,
            answers: [{ id: answerId, openAnswer: newValue }],
          },
        ]),
      )
    }
  }

  return (
    <BookingQuestionUiContainer>
      <BookingQuestionLabel
        htmlFor={question.id}
        fontSize={fieldFontSize}
        mobileFontSize={mobileFieldFontSize}
        lineHeight={fieldLineHeight}
        mobileLineHeight={mobileFieldLineHeight}
        color={formFieldTextColor}
        mobileColor={mobileFormFieldTextColor}
      >
        {question.title}
        {question.isRequired ? ' *' : ''}
      </BookingQuestionLabel>
      <CommonField
        value={value ?? ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleQuestionUpdate(answerId, e.target.value)
        }
        required={question.isRequired}
        id={question.id}
        placeholder={question.placeholder}
        boxShadow={fieldBoxShadow}
        mobileBoxShadow={mobileFieldBoxShadow}
        fontSize={fieldFontSize}
        mobileFontSize={mobileFieldFontSize}
        lineHeight={fieldLineHeight}
        mobileLineHeight={mobileFieldLineHeight}
        color={formFieldTextColor}
        mobileColor={mobileFormFieldTextColor}
        placeholderColor={formFieldPlaceholderColor}
        mobilePlaceholderColor={mobileFormFieldPlaceholderColor}
        border={fieldBorder}
        mobileBorder={mobileFieldBorder}
        padding={{
          paddingTop: 10,
          paddingRight: 0,
          paddingBottom: 10,
          paddingLeft: 0,
        }}
      />
    </BookingQuestionUiContainer>
  )
}

export default BookingCalendarQuestion
